import {VatDetail} from "@/scripts/Common";
import moment from "moment/moment";
import {DateFormats} from "@/scripts/Common/DateFormats";
import {formatDate} from "@/scripts/Common/helpers";

const compareVatDetailDates = (vatDetail1: VatDetail, vatDetail2: VatDetail) => {
  if (!vatDetail1.validFrom || !vatDetail2.validFrom) {
    return 0;
  }

  if (vatDetail1.validFrom > vatDetail2.validFrom) {
    return 1;
  }

  if (vatDetail1.validFrom < vatDetail2.validFrom) {
    return -1;
  }

  return 0;
}

const findActiveVatDetail = (vatDetails: VatDetail[]) => {
  vatDetails.sort(compareVatDetailDates);

  const now = moment(new Date(), DateFormats.YEAR_MONTH_DAY_TIME).format(DateFormats.YEAR_MONTH_DAY);

  if (vatDetails.length === 1) {
    if (formatDate(vatDetails[0].validFrom, DateFormats.YEAR_MONTH_DAY) <= now) {
      return vatDetails[0];
    }
  }

  if (vatDetails.length > 1) {
    let pastVatDetails = vatDetails.filter(x => formatDate(x.validFrom, DateFormats.YEAR_MONTH_DAY) <= now);

    if (pastVatDetails.length > 0) {
       return pastVatDetails[pastVatDetails.length - 1];
    }
  }

  return undefined;
}

export {
  findActiveVatDetail
}


